'use client';

import { CoursesPage } from '@into-discovery/browsewebshared';
import { usePathname } from '@/navigation';
import { i18n } from '@/i18n-config';
import { ICourseListProps } from '@/models/courseList/ICourseListProps';

type Props = {
  pageProps: ICourseListProps;
};

export default function CourseListProvider({ pageProps }: Props) {
  const pagePath = usePathname();

  return (
    <CoursesPage
      courses={pageProps?.courses}
      brand={pageProps?.brand}
      introText={pageProps?.introText}
      appSettings={pageProps?.appSettings}
      pagePath={pagePath}
      locales={i18n.locales}
      application={process.env.NEXT_PUBLIC_APPLICATION_NAME as string}
    />
  );
}
